import { Select } from "@mantine/core";
import { IChecklistPopulated } from "@mctypes/checklist.types";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { selectCurrentProjectId } from "../../../global/globalSliceCommon";
import { useAppSelector } from "../../../hooks";
import { useGetProjectChecklistTemplatesQuery, useGetProjectChecklistsQuery } from "./checklistRTK";
import { selectChecklist } from "./checklistSelectors";
import { ChecklistStatusEnum } from "./constants";

const EMPTY_CHECKLISTS: IChecklistPopulated[] = [];

const getChecklistPickerList = (
  checklist: IChecklistPopulated | null,
  projectChecklists: IChecklistPopulated[],
  projectTemplates: IChecklistPopulated[],
): IChecklistPopulated[] => {
  if (checklist == null) {
    return EMPTY_CHECKLISTS;
  }

  const checklists = checklist.isTemplate === true ? projectTemplates : projectChecklists;

  return checklists.filter(
    (item) =>
      item.status !== ChecklistStatusEnum.REMOVED &&
      item.status !== ChecklistStatusEnum.DELIVERED &&
      item.templateType !== "MC",
  );
};

const ChecklistPicker: React.FC<{ checklist?: IChecklistPopulated | null }> = ({ checklist: checklistProp }) => {
  const { checklistId } = useParams<{ checklistId: string }>();
  const selectedChecklist = useAppSelector((state) => selectChecklist(state, checklistId));
  const checklist = checklistProp ?? selectedChecklist;
  const projectId = useAppSelector(selectCurrentProjectId);

  const history = useHistory();

  const { data: projectChecklists = EMPTY_CHECKLISTS } = useGetProjectChecklistsQuery(
    {
      projectId: projectId ?? "",
    },
    { skip: projectId == null },
  );

  const { data: projectTemplates = EMPTY_CHECKLISTS } = useGetProjectChecklistTemplatesQuery(
    {
      projectId: projectId ?? "",
    },
    { skip: projectId == null },
  );
  const list = getChecklistPickerList(checklist, projectChecklists, projectTemplates);

  const goToChecklist = (checklistId: string) => {
    if (projectId == null) return;
    history.push(`/project/${projectId}/checklist/instance/${checklistId}`);
  };

  const goToChecklistSelection = () => {
    if (projectId == null) return;
    history.push(`/project/${projectId}/checklist`);
  };

  const handleSelectChange = (checklistId: string | null) => {
    if (checklistId === "selection") {
      goToChecklistSelection();
    } else if (checklistId) {
      goToChecklist(checklistId);
    }
  };

  return (
    <>
      {list.length > 0 && (
        <Select
          w="lg"
          size="sm"
          value={checklist?._id || "selection"}
          onChange={handleSelectChange}
          placeholder={checklist?.name || "Velg sjekkliste"}
          data={[
            ...list.map((cl) => ({
              value: cl._id,
              label: cl.name,
            })),
            { value: "selection", label: "Gå til Utvalg" },
          ]}
          style={{ minWidth: "200px" }}
          searchable
        />
      )}
    </>
  );
};

export default ChecklistPicker;
